import { useState } from 'react';
import { employeeApi } from '../../../lib/api';
import { capturePhoto, deviceMeta } from '../../../lib/photo';
import { useEmployee } from '../EmployeeContext';
import { errorMessage } from '../../../components/ErrorModalBody';

function nowISO() { return new Date().toISOString(); }

export function DocumentPhotoCapture({ onSaved }: { onSaved: () => void }) {
  const { employee } = useEmployee();
  const [photo, setPhoto] = useState<string | null>(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function capture() {
    setError('');
    const p = await capturePhoto('environment', [employee.nome, 'Documento de identificação', new Date().toLocaleString('pt-BR')]);
    if (!p) { setError('É necessário fotografar o documento para continuar usando o sistema.'); return; }
    setPhoto(p);
  }

  async function save() {
    if (!photo) return;
    setBusy(true);
    setError('');
    try {
      await employeeApi.saveDocumentPhoto({ imagem: photo, criadaEm: nowISO(), device: deviceMeta() });
      onSaved();
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  if (photo) {
    return (
      <>
        <h2>Confirme a foto do documento</h2>
        <p className="hint">A foto ficou legível? Dá pra ler os dados claramente?</p>
        <div style={{ textAlign: 'center' }}><img src={photo} style={{ maxWidth: '100%', borderRadius: 12 }} /></div>
        {error && <div className="err">{error}</div>}
        <div className="row" style={{ marginTop: 14 }}>
          <button className="btn btn-ghost" style={{ flex: 1 }} onClick={() => setPhoto(null)}>Refazer</button>
          <button className="btn btn-primary" style={{ flex: 1 }} disabled={busy} onClick={save}>Está boa, confirmar</button>
        </div>
      </>
    );
  }

  return (
    <>
      <h2>Foto do seu documento</h2>
      <p className="hint">Antes do seu primeiro registro, tire uma foto legível de um documento oficial de identificação com foto (RG, CNH ou CPF). Você só faz isso uma vez.</p>
      {error && <div className="err">{error}</div>}
      <button className="btn btn-primary btn-block" onClick={capture}>Tirar foto do documento</button>
    </>
  );
}
